import {makeAutoObservable} from 'mobx';

export class DataState {
  constructor() {
    makeAutoObservable(this);
  }
}

export const dataState = new DataState();
